import { Component, OnInit, Input, ViewEncapsulation, OnDestroy, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmitterService } from '../../../services/emitter.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import * as _ from 'underscore';
import { Utility } from '../../../shared/utility/utility';
import { NavigationService } from '../../../services/navigation.service';
@Component({
  selector: 'app-lobby-tabs',
  templateUrl: './lobby-tabs.component.html',
  styleUrls: ['./lobby-tabs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LobbyTabsComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() lobbyDetails;
  @Input() categoryType;
  @Input() skeltonLoader;
  @Input() homePage;
  @Input() currentGameGroupsList:any = [];
  @Input() fromNav;
  langCode;
  activeLobby;
  destroy$: Subject<boolean> = new Subject();
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  actualLanguage = '';
  isGameGroupPageActive = false;
  activeGameGroupName = '';
  isLoggedIn: boolean;
  windowType: string;
  homeLobbies = [];
  constructor(
    private emitterService: EmitterService,
    private activatedRoute: ActivatedRoute,
    public utils:Utility,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    
    this.langCode = localStorage.getItem('langCode');
    this.actualLanguage = this.utils.getActualMappedLanguage(this.langCode);
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
    this.activeLobby = this.categoryType;
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
       if(params["gamegroup"] === "allgames") {
        this.activeLobby = "allgames";
      }else{
        _.find(this.lobbyDetails, (lobby) => {
          if(params["gamegroup"] === lobby.multilingualUrlLobby[this.utils.getActualMappedLanguage(this.langCode)]) {
            this.activeLobby = lobby.id;
          }
        })
      }
      this.checkHomeLobbies();
    })
    let paramMap = this.activatedRoute.snapshot;
    if(paramMap.params.gamegrouptype && paramMap.params.gamegrouptype!= ""){
      this.isGameGroupPageActive = true;
    } else {
      this.isGameGroupPageActive = false;
    }
    
    if(this.currentGameGroupsList && this.currentGameGroupsList[0] && this.currentGameGroupsList[0].name){
      this.activeGameGroupName = this.currentGameGroupsList[0].name;
    }else{
      this.activeGameGroupName = paramMap.params.gamegrouptype ? paramMap.params.gamegrouptype.replaceAll("_"," "): "";
    }
    this.isLoggedIn = this.utils.isUserLoggedIn();
    this.getWindowType();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.checkHomeLobbies();
  }
 
  checkHomeLobbies(){
    this.homeLobbies = [];
    if(this.lobbyDetails && this.lobbyDetails.length){
      this.homeLobbies = this.lobbyDetails.filter((lobby:any)=> lobby['title'].toLowerCase().includes('-home'));
      this.homeLobbies = this.homeLobbies && this.homeLobbies.length ? this.homeLobbies.slice(0,3) : [];
    }
  }

  ngAfterViewInit(): void {
    let paramMap = this.activatedRoute.snapshot;
    if(paramMap.params.gamegroup && paramMap.params.gamegroup != "" && !this.isGameGroupPageActive){
      document.getElementById(paramMap.params.gamegroup)?.scrollIntoView(false);
    }
    setTimeout(() => {
      this.initVerticalScroll(".lobby_pills_group_scroll_h");
    },100);
  }

  setActiveLobby(id) {
    this.activeLobby = id;
    this.emitterService.broadCastShowSearchBar(false);
  }

  goBack() {
    this.navigationService.back();
    this.emitterService.broadCastShowSearchBar(false);
  }

 initVerticalScroll(elem){
    const scrollContainer = document.querySelector(elem);
    if(scrollContainer){
      scrollContainer.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollContainer.scrollLeft += evt.deltaY;
    });
    }
  }

  getWindowType(){
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }

  ngOnDestroy(){
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
